import axios from "axios";
import Dropzone from "dropzone";

const warrantyRequest = () => ({
  errors: {},

  isSubmitting: false,

  dropzones: {
    client_dni: null,
    invoice: null,
    product_code: null,
    product_photos: null,
    imperfection: null,
  },

  form: {
    client_name: null,
    client_email: null,
    client_phone: null,
    client_dni: null,

    store_name: null,
    contributor_name: null,

    claim_description: null,
    product_brand: null,
    purchase_date: null,

    images: {
      client_dni: null,
      invoice: null,
      product_code: null,
      product: null,
      imperfection: null,
    },
  },

  modals: {
    confirm: jQuery("#confirm-modal"),
    success: jQuery("#success-modal"),
    error: jQuery("#error-modal"),
  },

  handle_validation_errors(errors) {
    this.errors = errors;
    jQuery("html").animate({ scrollTop: 0 }, "slow");
  },

  async handle_submit() {
    try {
      if (this.isSubmitting) return;

      this.isSubmitting = true;

      const body = new FormData();
      body.append("action", "innovabikes_handle_warranty_request_submit");

      if (this.form.client_name) body.append("client_name", this.form.client_name);
      if (this.form.client_email) body.append("client_email", this.form.client_email);
      if (this.form.client_phone) body.append("client_phone", this.form.client_phone);
      if (this.form.client_dni) body.append("client_dni", this.form.client_dni);
      if (this.form.store_name) body.append("store_name", this.form.store_name);
      if (this.form.contributor_name) body.append("contributor_name", this.form.contributor_name);
      if (this.form.claim_description) body.append("claim_description", this.form.claim_description);
      if (this.form.product_brand) body.append("product_brand", this.form.product_brand);
      if (this.form.purchase_date) body.append("purchase_date", this.form.purchase_date);

      this.dropzones.client_dni.files.forEach((file) => body.append("client_dni_img[]", file));
      this.dropzones.invoice.files.forEach((file) => body.append("invoice_img[]", file));
      this.dropzones.product_code.files.forEach((file) => body.append("product_code_img[]", file));
      this.dropzones.product_photos.files.forEach((file) => body.append("product_photos_img[]", file));
      this.dropzones.imperfection.files.forEach((file) => body.append("imperfection_img[]", file));

      const { data } = await axios({ method: "post", data: body });

      const { status, errors } = data;

      this.modals.confirm.hide();

      this.isSubmitting = false;

      if (!status) {
        if (errors) {
          this.handle_validation_errors(errors);
          return;
        }

        this.modals.error.show();
        return;
      }

      this.modals.success.show();
    } catch (error) {
      console.log(error);
      this.isSubmitting = false;
      this.modals.error.show();
    } 
  },

  init_dropzone(key, el, maxFiles = null) {
    const dropzoneMsg = el + "-msg";

    const config = {
      url: "/",
      autoProcessQueue: false,
      clickable: [el, dropzoneMsg].join(", "),
      previewTemplate: `
        <div>
          <div style="position: relative;">
            <img data-dz-thumbnail />
            <div class="dz-size" data-dz-size></div>
            <div style="color: white; position: absolute; top: -8px; right: -8px; display: flex; width: 1.5rem; height: 1.5rem; justify-content: center; align-items: center; background: red; border-radius: 50%;" data-dz-remove>
              <svg style="width: 1rem; height: 1rem;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </div>
          </div>
        </div>
      `,
    };

    if (maxFiles) config.maxFiles = maxFiles;

    const dropzone = (this.dropzones[key] = new Dropzone(el, config));

    if (maxFiles == 1) {
      dropzone.on(
        "addedfile",
        () =>
          dropzone.files.length > 1 && dropzone.removeFile(dropzone.files[0])
      );
    }

    dropzone.on(
      "addedfile",
      () => dropzone.files.length >= 1 && jQuery(dropzoneMsg).hide()
    );

    dropzone.on(
      "removedfile",
      () => dropzone.files.length < 1 && jQuery(dropzoneMsg).show()
    );
  },

  init() {
    this.init_dropzone("client_dni", "#client-dni-img", 2);
    this.init_dropzone("invoice", "#invoice-img", 2);
    this.init_dropzone("product_code", "#product-code-img", 1);
    this.init_dropzone("product_photos", "#product-photos-img", 6);
    this.init_dropzone("imperfection", "#imperfection-img", 2);
  },
});

window.warrantyRequest = warrantyRequest;
